/**
 * Singleton holding the live DOM anchor for the WAM instructions menu.
 *
 * `EditorView` renders an empty `<div>` inside its workspace panel and
 * passes `setWamInstructionsMenuHost` as the React `ref` callback. The
 * desktop `WamInstructionsMenu` portals itself into that element, and
 * the editor's click-outside / `selection:cleared` guards use it to
 * recognise clicks that originated inside the menu.
 */
let host: HTMLElement | null = null;

/**
 * React `ref` callback that should be attached to the host `<div>` inside
 * `EditorView`. React calls it with the element on mount and with `null`
 * on unmount, so the value here always matches the live DOM.
 */
export const setWamInstructionsMenuHost = (element: HTMLElement | null): void => {
  host = element;
};

/** Returns the currently mounted host element, or `null` if none is mounted. */
export const getWamInstructionsMenuHost = (): HTMLElement | null => host;

/**
 * Convenience helper used by click-outside / `selection:cleared` guards
 * to recognise interactions that happened inside the menu (and should
 * therefore not deselect the active canvas object).
 */
export const isInsideWamInstructionsMenu = (target: EventTarget | Element | null): boolean => {
  if (!host || !target || !(target instanceof Element)) {
    return false;
  }
  return host.contains(target);
};
